import instance from "./index";

const normalizeProvider = (provider) => ({
  ...provider,
  providerId:
    provider?.providerId ??
    provider?.ProviderId ??
    provider?.id ??
    provider?.Id ??
    null,
  providerName:
    provider?.providerName ??
    provider?.ProviderName ??
    provider?.name ??
    "",
  statusId:
    provider?.statusId ??
    provider?.StatusId ??
    null,
});

const normalizeModel = (model) => ({
  ...model,
  modelId:
    model?.modelId ??
    model?.ModelId ??
    model?.id ??
    model?.Id ??
    null,
  modelVersion:
    model?.modelVersion ??
    model?.ModelVersion ??
    model?.name ??
    "",
  statusId:
    model?.statusId ??
    model?.StatusId ??
    null,
  providerId:
    model?.providerId ??
    model?.ProviderId ??
    null,
});

export const getAllProviders = async () => {
  try {
    const response = await instance.get("/provider");
    const data = response?.data;
    const list = Array.isArray(data)
      ? data
      : Array.isArray(data?.data)
        ? data.data
        : [];

    return list.map(normalizeProvider).filter((item) => item.providerId != null);
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to load providers";
    throw new Error(message);
  }
};

export const getAllModelsByProviderId = async (providerId) => {
  if (providerId === undefined || providerId === null || providerId === "") {
    throw new Error("Provider id is required");
  }

  try {
    const response = await instance.get(
      `/model/getAllModelByProviderId/${providerId}`,
    );
    const data = response?.data;
    const list = Array.isArray(data)
      ? data
      : Array.isArray(data?.data)
        ? data.data
        : [];

    return list.map(normalizeModel).filter((item) => item.modelId != null);
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to load models";
    throw new Error(message);
  }
};
